import { render } from "./SelectProjects.vue?vue&type=template&id=3b1439ea&scoped=true"
import script from "./SelectProjects.vue?vue&type=script&lang=js"
export * from "./SelectProjects.vue?vue&type=script&lang=js"

import "./SelectProjects.vue?vue&type=style&index=0&id=3b1439ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1439ea"]])

export default __exports__